/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomPublishingChannel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 16c-.5 0-.9.1-1.3.3L16 14.6V9.4l1.7-1.7c.4.2.8.3 1.3.3 1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3c0 .5.1.9.3 1.3L14.6 8H9.4L7.7 6.3c.2-.4.3-.8.3-1.3 0-1.7-1.3-3-3-3S2 3.3 2 5s1.3 3 3 3c.5 0 .9-.1 1.3-.3L8 9.4v5.1l-1.7 1.7c-.4-.1-.8-.2-1.3-.2-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3c0-.5-.1-.9-.3-1.3L9.4 16h5.2l1.7 1.7c-.2.4-.3.8-.3 1.3 0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3zm0-12c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM5 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm0 14c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm9-6h-4v-4h4zm5 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCustomPublishingChannel as CustomPublishingChannel };
